import cn from 'clsx';
import { observer } from 'mobx-react-lite';

import { useStore } from 'hooks/useStore';
import { interpolate } from 'utils/string/format';

import { SMS } from '../SMS';

import css from './Trial.module.css';

interface ITrial {
  mode: 'full' | 'short';
}

const Trial = ({ mode }: ITrial) => {
  const {
    app: { i18n },
    savedFilters: { popup },
    profile,
  } = useStore();

  if (
    !popup?.notificationsRate ||
    !popup.hasSubscriptionTrial ||
    !popup.smsParams ||
    profile.hasUnlimitedNotificationsLicense ||
    popup.hasOnlyPersonalBoards
  ) {
    return null;
  }

  if (mode === 'short' && popup.hasSubscription.value) return null;

  const trialExpiration = popup.validationResult?.trialVersionEndDateTime
    ? interpolate(i18n.subscriptions.trial.exactDate[mode], { date: popup.validationResult?.trialVersionEndDateTime })
    : interpolate(i18n.subscriptions.trial.freeDays[mode], {
        days: popup.validationResult?.cargoSubscriptionsTrialDaysDuration?.toString() || '',
      });

  return (
    <div className={cn(css.trial, css[`trial_${mode}`])}>
      <span className={css.special}>{i18n.subscriptions.trial.special}</span>

      <span className={css.desc}>
        <strong>{trialExpiration}</strong>
        <span> {interpolate(i18n.subscriptions.trial.priceAfter, { atis: popup?.notificationsRate.toString() })}</span>
      </span>
      <SMS />
    </div>
  );
};

const connected = observer(Trial);

export { connected as Trial };
